var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 3.748h7.2v1.8H5.4zm10.89.9H18c0-2.484-2.016-4.5-4.5-4.5H9.9v1.71h3.6a2.79 2.79 0 0 1 2.79 2.79m-14.58 0a2.79 2.79 0 0 1 2.79-2.79h3.6V.148H4.5a4.5 4.5 0 0 0-4.5 4.5c0 2.484 2.016 4.5 4.5 4.5h3.6v-1.71H4.5a2.79 2.79 0 0 1-2.79-2.79m13.59 0h-1.8v2.7h-2.7v1.8h2.7v2.7h1.8v-2.7H18v-1.8h-2.7z"
  })));
};
export default SvgLink;